import { render, staticRenderFns } from "./ThemeHeroVideo.vue?vue&type=template&id=4c856d41&"
import script from "./ThemeHeroVideo.vue?vue&type=script&lang=js&"
export * from "./ThemeHeroVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports